module.exports = __webpack_public_path__ + "static/london-1-9d565c9c7b397041cf5ad4ed1edf88dd.jpg";